<template>
    <div>
        <app-nav/>
        <main class="vh-80">
            <div class="container top-50-percent">
                <p class="mb-1"><b>{{ $t('Thank you for your booking request on') }}.</b></p>
                <p class="mb-1">{{ $t('We will review your request and respond within a few hours, but no later than the morning of next business day') }}.</p>
                <p class="mb-1">{{ $t('If you want to get the vehicle faster, please call') }} (+372) 53 555 999.</p>
                <p class="mb-1"><b>NB! {{ $t('Your booking has not yet been confirmed') }}.</b></p>
            </div>
        </main>
        <app-footer />
    </div>
</template>

<script>
import AppNav from '@components/layout/public/Nav';
import AppFooter from '@components/layout/public/Footer';

export default {
    components: {
        AppNav,
        AppFooter
    }
};
</script>
<style scoped>
.top-50-percent {
    top: 35%;
    left: 15%;
    max-width: 70%;
    min-height: 25%;
    position: absolute;
}
</style>
